// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a15af968","337":"33959edb","453":"04bc31f9","553":"7dfa5589"}[chunkId] + ".chunk.js";
};